import { DeepLinkFeature } from 'const/deepLink'

const FEATURE_KEY = 'deepLinkFeature'

const deepLinkStorage = {
  setClient(client: string, clientId?: string): void {
    const deepLinkClient = clientId || client
    sessionStorage.setItem('deepLinkClient', deepLinkClient)
  },

  getClient(): string | null {
    return sessionStorage.getItem('deepLinkClient')
  },

  setFeature(feature: DeepLinkFeature): void {
    sessionStorage.setItem(FEATURE_KEY, feature)
  },

  getFeature(): DeepLinkFeature | null {
    return sessionStorage.getItem(FEATURE_KEY) as DeepLinkFeature | null
  },

  clearFeature(): void {
    sessionStorage.removeItem(FEATURE_KEY)
  },

  clearAll(): void {
    sessionStorage.removeItem('deepLinkClient')
    sessionStorage.removeItem(FEATURE_KEY)
  }
}

export default deepLinkStorage
